<template>
  <div>
    <el-dialog
      title="Insert channel"
      :visible="dialog_insert"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialogInsert(false)"
    >
      <el-form label-position="top">
        <el-form-item label="Channel" prop="channel">
          <el-input type="text" v-model="channel" clearable />
        </el-form-item>

        <el-form-item label="Select Labels" prop="labels">
          <el-select
            v-model="selectedLabels"
            multiple
            filterable
            clearable
            placeholder="Select labels"
            style="width: 100%"
            collapse-tags
            collapse-tags-tooltip
            :max-collapse-tags="4"
            @change="handleLabelChange"
          >
            <el-option
              :key="'selectAll'"
              :label="'Select All'"
              :value="0"
              :disabled="labels.length === 0"
            />
            <el-option
              v-for="label in labels"
              :key="label.id"
              :label="label.name"
              :value="label.id"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      channel: '',
      selectedLabels: []
    }
  },
  computed: {
    ...mapState('youtubeWhitelist', ['dialog_insert', 'loading', 'labels'])
  },
  mounted() {
    this.getLabels()
  },
  methods: {
    ...mapActions('youtubeWhitelist', ['insert', 'getLabels']),
    ...mapMutations('youtubeWhitelist', ['setDialogInsert']),

    submit() {
      if (!this.channel || this.selectedLabels.length === 0) {
        this.$message.error('Please fill out both fields before submitting.')
        return
      }

      // Call the insert method and pass the channel and selected labels

      this.insert({ channelId: this.channel, labelIds:JSON.parse(JSON.stringify(this.selectedLabels)) })
      this.setDialogInsert(false)
      this.channel = ''
      this.selectedLabels = []
    },

    handleLabelChange(selectedLabels) {
      const lastSelected = selectedLabels[selectedLabels.length - 1]

      if (lastSelected === 0) { // Select All
        this.selectedLabels = this.labels.map(label => label.id)
      } else if (lastSelected === -1) { // Deselect All
        this.selectedLabels = []
      } else {
        // Remove special values (0 and -1) if they exist in the array
        this.selectedLabels = selectedLabels.filter(
          value => value !== 0 && value !== -1
        )
      }
    }
  }
}
</script>

<style scoped>
/* Scoped styles for this component */
.el-select {
  width: 100%;
}

/* Global styles should be in your main CSS file */
:deep(.custom-select-dropdown) {
  max-height: 300px;
  overflow-y: auto;
}

:deep(.custom-select-dropdown.with-scroll) {
  max-width: 450px;
  width: 450px;
}

/* Style for selected tags */
:deep(.el-select__tags) {
  max-height: 100px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
</style>